import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PortalUserService } from '@aifs-shared/portal/portal-user-service';
import { ApplicantService } from '../applicant/applicant.service';
import { ApplicantDetailChanged, ChangedItem } from '../applicant/applicant-detail-changed';
import { ApplicantQueueItem, InterviewerQueueResponse, InterviewerQueueType, InterviewerService } from './interviewer.service';

@Component({
    selector: 'app-interview-ready-interviews',
    templateUrl: './interview-ready-interviews.component.html',
    styleUrls: ['./style/applicant-view-styles.scss']
})
export class InterviewReadyInterviewsComponent implements OnInit {
    @Input() interviewerId: number = 0;

    constructor(
        private router: Router,
        private appService: ApplicantService,
        private userService: PortalUserService,
        private interviewer: InterviewerService) {
    }

    ngOnInit(): void {
        this.getInterviewReadyApplicants();
        this.changeSubscription = this.appService.applicantDetailsChanged$.subscribe({
            next: (changeItem: ApplicantDetailChanged) => {
                if (changeItem.changedItem === ChangedItem.Interview || changeItem.changedItem === ChangedItem.ApplicationSubmittedToOffice) {
                    const inList = this.applicants.findIndex(a => a.applicationId === changeItem.applicationId);
                    if (inList > -1) this.getIncompleteInterviewReports();
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.changeSubscription.unsubscribe();
    }

    private getIncompleteInterviewReports(): void {
        this.noData = true;
        this.isLoading = true;
        this.getInterviewReadyApplicants();
    }

    getInterviewReadyApplicants() {
        const iv = this.interviewerId === 0 ? this.userService.getInterviewerId() : this.interviewerId;
        this.interviewer
            .getApplicantByQueueForInterviewer(iv, InterviewerQueueType.InterviewReady)
            .subscribe({
                next: (result: InterviewerQueueResponse) => {
                    this.populateData(result);
                },
                error: (error: any) => { console.error(error); this.isLoading = false; }
            });
    }

    private populateData(result: InterviewerQueueResponse) {
        if (result.details) {
            this.applicants = result.details.items;
            this.count = this.applicants.length;
            if (this.count > 0) {
                this.noData = false;
            }
            this.isLoading = false;
        }
    }

    openApplicant(a: ApplicantQueueItem): void {
        // CA-3155
        if(this.interviewerId !== 0 ) {
            // Placed in a timeout so that we don't hijack
            // the rest of the event.
            setTimeout( () => {
                // Update local view:
                a.isNewToUser = false;

                // Force refresh
                this.applicants = this.applicants.slice();
            }, 500);
            // This is actually done in the applicant details component now
            // Notify server (this view is the only one right now)
            // this.interviewer.updateInterviewerViewedApplication(this.interviewerId, a.applicationId, 1);
        }

        const link = `/applicant/${a.applicantId}/${a.applicationId}`;
        this.router.navigate([]).then(result => { window.open(link, '_blank'); });
    }

    useInterviewerId: number = 0;
    noData = false;

    applicants: ApplicantQueueItem[] = [];
    count = 0;

    isLoading = true;
    showInterviewer = false;
    changeSubscription!: Subscription;
}